import { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PinGuard() {
  const alreadyVerified = sessionStorage.getItem('pin_verified') === 'true';
  const [status, setStatus] = useState(alreadyVerified ? 'allowed' : 'checking');

  useEffect(() => {
    if (alreadyVerified) return;
    let cancelled = false;
    axios.get(`${API}/api/settings/platform`, { timeout: 10000 }).then(res => {
      if (cancelled) return;
      if (!res.data.gate_pin_enabled) {
        sessionStorage.setItem('pin_verified', 'true');
        setStatus('allowed');
      } else {
        setStatus('blocked');
      }
    }).catch(() => {
      if (!cancelled) setStatus('blocked');
    });
    return () => { cancelled = true; };
  }, [alreadyVerified]);

  if (status === 'checking') return null;
  if (status === 'blocked') return <Navigate to="/" replace />;
  return <Outlet />;
}
